import AssigneeSelector from '../../../conversations/AssigneeSelector';
import { useCommunicationAssignment } from '../../../../hooks/useCommunicationAssignment';
import type { Communication } from '../../../../services/communications';

interface CommunicationAssigneeCellProps {
    communication: Communication;
    /** Opens the menu upwards for rows near the bottom of the clipped scroll body. */
    dropUp: boolean;
}

// Its own component (not a plain render callback) because
// useCommunicationAssignment is a hook - DataTable invokes a column's
// `render` as a plain function, and hooks can only run inside a component.
export function CommunicationAssigneeCell({
    communication,
    dropUp
}: CommunicationAssigneeCellProps) {
    const { currentUserEmail, handleAssign, handleUnassign } =
        useCommunicationAssignment(communication);

    return (
        <AssigneeSelector
            assignedTo={communication.assignee?.email ?? null}
            dropUp={dropUp}
            dropdownAlign="left"
            onAssign={handleAssign}
            onUnassign={handleUnassign}
            currentUserEmail={currentUserEmail}
        />
    );
}
